/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  if (!($(".js-lightbox").length > 0)) { return; }

  $.showLightbox = function(lightbox_id) {
    var $lightbox = $("#".concat(lightbox_id));
    if (lightbox_id === 'lightbox-must-upgrade-gold') {
      $.setDefaultPaymentPageTier('gold');
    } else if (['lightbox-must-upgrade-silver', 'lightbox-must-upgrade-score'].includes(lightbox_id)) {
      $.setDefaultPaymentPageTier('silver');
    }
    return $lightbox.reveal();
  };

  $.hideLightbox = function(lightbox_id) {
    return $('.js-lightbox').trigger('reveal:close');
  };

  $.attachBronzeMustConfirmLightboxHandlers = function() {
    // Disable resend button on click
    $(".js-lightbox input[type='submit']").on('click', function() {
      return $(this).prop('disabled', true);
    });
    // Lightbox resend button
    return $(document).on('ajax:complete', function(event, xhr, settings) {
      if ($(event.target).parents('.js-lightbox').length > 0) {
        return $.hideLightbox();
      }
    });
  };

  // Hide lightbox on .hide-lightbox click
  $('.js-hide-lightbox').on('click', $.hideLightbox);

  // Show lightbox on page interaction
  if ($('#lightbox-bronze-must-confirm-email').length > 0) {
    if (!document.location.href.match(/\/purchase\/|\/contact-us|\/general\/learn-more/)) {
      $.attachBronzeMustConfirmLightboxHandlers();
    }
  }

  // Show lightbox on page load
  if (!document.location.href.match(/\/purchase\/|\/contact-us|\/general\/learn-more/)) {
    if ($('#lightbox-email-confirmed').length > 0) {
      return $.showLightbox("lightbox-email-confirmed");
    } else if ($('#lightbox-please-confirm-email').length > 0) {
      return $.showLightbox("lightbox-please-confirm-email");
    } else if ($('#lightbox-bronze-must-confirm-email').length > 0) {
      return $.showLightbox("lightbox-bronze-must-confirm-email");
    } else if ($('#lightbox-must-upgrade-gold').length > 0) {
      return $.showLightbox("lightbox-must-upgrade-gold");
    } else if ($('#lightbox-must-upgrade-silver').length > 0) {
      return $.showLightbox("lightbox-must-upgrade-silver");
    }
  }
});
